__webpack_require__.p = "https://assets.airtel.in/static-assets/b2b-internet-leased-line-ui/";